import { AxiosResponse } from "axios";
import { useQuery } from "react-query";
import { getTrackingRowsAndTotal } from "./helpers";
import { BarcodeTrackingRow } from "./types";
import SupplyManagmentService from "Services/SupplyManagement/SupplyManagmentService";

const defaultQueryOptions = {
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
};

export const trackingQueryKeys = {
  all: ["supply-management-tracking"],
  barcodes: (params: any) => [...trackingQueryKeys.all, "barcodes", params],
};

export const useBarcodeTracking = (params: any) =>
  useQuery<
    AxiosResponse<any>,
    Error,
    { rows: BarcodeTrackingRow[]; total: number }
  >(
    trackingQueryKeys.barcodes(params),
    () => SupplyManagmentService.getBarcodeTracking(params),
    {
      ...defaultQueryOptions,
      keepPreviousData: true,
      select: (response) => getTrackingRowsAndTotal(response),
    }
  );
